<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Survey & Referral</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Marketing</b>
      /
      <b>Survey & Referral</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Survey & Referral points</h4>

            <!-- Points Table -->
            <div class="table-responsive">
              <table
                id="survey_referral_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Type</th>
                    <th>Points Earn</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(event, index) in events" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ event.name }}</td>
                    <td>{{ event.points }}</td>
                    <td>
                      <router-link
                        :to="redirect(event.id)"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "surveyReferral-view",

  data() {
    return {
      events: []
    };
  },

  methods: {
    loadRate() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/event", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.events = res.data.events;
          })
          .then(function() {
            $("#survey_referral_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2]
                  }
                }
              ]
            });
          });
      }
    },

    loadData() {
      this.destroyDatatable();
      this.loadRate();
    },

    redirect(id) {
      return "/marketing/survey-referral/details/" + id;
    },

    destroyDatatable() {
      $("#survey_referral_tbl")
        .DataTable()
        .destroy();
    }
  },

  mounted() {
    this.loadData();
  }
};
</script>
